module.exports = __webpack_public_path__ + "static/media/logoInitial.73a45e16.png";